export const Logo = ({ compact = false }) => (
  <span className="inline-flex items-center gap-3 select-none">
    <svg width="34" height="34" viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="14" fill="none" stroke="#D4AF37" strokeOpacity="0.55" strokeWidth="2.5" />
      <path d="M23 47V17h7.5c8.4 0 13.5 5.6 13.5 15s-5.1 15-13.5 15H23z" fill="none" stroke="#D4AF37" strokeWidth="3.4" />
      <circle cx="47" cy="18" r="2.4" fill="#D4AF37" />
      <circle cx="52.5" cy="11.5" r="1.7" fill="#D4AF37" opacity=".7" />
      <circle cx="42" cy="10.5" r="1.3" fill="#D4AF37" opacity=".45" />
    </svg>
    {!compact && (
      <span className="font-serif tracking-[0.22em] text-cream text-lg leading-none">
        DEO&nbsp;ATELIER
      </span>
    )}
  </span>
);

export default Logo;
